export default __webpack_public_path__ + "static/media/victory-sm.0478a19a.png";